// Base Url
export const BASE_URL = process.env.REACT_APP_BASE_URL || "";
export const NODE_BASE_URL = process.env.REACT_APP_NODE_BASE_URL || "";
export const NODE_HOST = process.env.REACT_APP_NODE_HOST || "";

// Login
export const LOGIN = "/api/auth/login";

// School controllerp
export const GET_ALL_SCHOOL_TYPES = "api/school/get-all-school-type";
export const GET_ALL_SCHOOLS = "api/school/get-all-schools-dropdown";
export const GET_ALL_SPORTS = "api/school/get-all-sport";
export const GET_ALL_COUNTRIES = "api/school/loadAllCountries";
export const ADD_SCHOOL_ADMIN_REGISTRATION = "api/school/add-school-admin";
export const SATTE_LISTED_BY_COUNTRY_ID = "api/school/getAllStates/";
export const CHECK_EMAIL_IN_USE = "api/auth/checkEmailInUse?email=";
